import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from './baseApi';
import './categoryApi';
import './subcategoryApi';
import './productApi';
import './productCategoryApi';
import './productSubcategoryApi';
import './outletApi';
import './bannerApi';
import './announcementApi';
import './noticeBoardApi';
import './emailHistoryApi';
import './licenceApi';
import './vendorApi';
import './behaviourApi';
import './dailySalesApi';
import './productTypeApi';
import './myToolsApi';
import './closingStockApi';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

